/**
 * 如果当前是必填项
 * @param value 当前输入的值
 */
const isRequired = value => {
  if (!value && value !== 0) {
    return '请输入内容'
  }
}

/**
 * 如果当前是身份证号
 * @param value 当前输入的值
 */
export const isIdcard = value => {
  if (`${value}`.length !== 18) {
    return '请输入正确的身份证号码'
  }
}

/**
 * 如果当前是VIN码
 * @param value 当前输入的值
 */
export const isVin = value => {
  if (`${value}`.length !== 17) {
    return '请输入正确的VIN码，长度不正确'
  } else if (!/^([0-9]|[a-z]|[A-Z]){17}$/.test(value)) {
    return '请输入正确的VIN码，格式不正确'
  }
}

export const isIccid = value => {
  if (`${value}`.length !== 20) {
    return '请输入正确的ICCID'
  }
}

/**
 * 是否是身份证号
 * @param value 当前输入的值
 */
const isIdcardPic = value => {
  if (!value || value.length === 0 || value.length !== value.filter(v => !!v).length) {
    return '请上传证件照片'
  }
  // 如果上传照片小于2张
  if (value.length < 2) {
    return '请至少上传2张证件照片'
  }
}

/**
 * 当前是否是照片
 * @param value 当前输入的值
 */
const isEmptyPics = value => {
  if (!value || value.length === 0) {
    return '请上传文件'
  }
}

/**
 * 当前是否是正确的手机号
 * @param value 当前输入的值
 */
const isPhone = value => {
  if (!`${value}`.match(/^1\d{10}$/)) {
    return '请输入正确的手机号'
  }
}

/**
 * 企业名称长度>=5
 * @param value 当前输入的值
 */
const companyNameLenGT5 = value => {
  if (value.length < 5) {
    return '请输入完整名称'
  }
}

/**
 * 地址长度>=4
 * @param value 当前输入的值
 */
const addressLenGT4 = value => {
  if (value.length < 4) {
    return '请输入完整地址'
  }
}

/**
 * 地址格式校验
 * @param value 当前输入的值
 */
const checkAddress = value => {
  if (!(value.indexOf('省') > 0 || value.indexOf('市') > 0 || value.indexOf('区') > 0 || value.indexOf('县') > 0 || value.indexOf('盟') > 0 || value.indexOf('旗') > 0 || value.indexOf('州') > 0 || value.indexOf('镇') > 0 ||
  value.indexOf('村') > 0 || value.indexOf('园') > 0 || value.indexOf('路') > 0 || value.indexOf('院') > 0 || value.indexOf('号') > 0)) {
    return '请填写完整地址，如“省市区县“等描述!'
  }
}

/**
 * 单位地址格式校验
 * @param value 当前输入的值
 */
// const checkEnterpriseAddress = value => {
//   if (!(value.indexOf('省') > 0 || value.indexOf('市') > 0 || value.indexOf('区') > 0 || value.indexOf('县') > 0 || value.indexOf('盟') > 0 || value.indexOf('旗') > 0 || value.indexOf('州') > 0 || value.indexOf('镇') > 0)) {
//     return '请填写完整地址，如“省市区县“等描述!'
//   }
// }

// 等待校验的规则
const rules = {
  certType: [isRequired],
  fullName: [isRequired],
  gender: [isRequired],
  certAddress: [isRequired],
  certExpirationDate: [isRequired],
  certNumber: [isRequired],
  certPic: [isIdcardPic],
  contractPic: [isEmptyPics],
  purchaseContractPic: [isEmptyPics],
  transferCertificatePic: [isEmptyPics],
  authorizationLetterPic: [isEmptyPics],
  vin: [isRequired, isVin],
  iccid: [isRequired, isIccid],
  phone: [isRequired, isPhone],
  companyName: [isRequired, companyNameLenGT5],
  companyCertNumber: [isRequired],
  companyCertAddress: [isRequired, addressLenGT4, checkAddress],
  companyContactAddress: [isRequired]
}

/**
 * 校验用户输入
 * @param  校验参数
 */
export function validate(values, ruleKeys = ['fullName', 'gender', 'certType', 'certNumber', 'certAddress', 'certExpirationDate']) {
  // 校验位置的索引
  let index = 0
  // 校验结果
  let result = true
  // 校验失败字段
  let failField = ''
  // 错误描述
  let failMessage = ''
  // 如果当前没有遍历完全
  while (index < ruleKeys.length && result) {
    // 当前需要校验的key
    const ruleKey = ruleKeys[index]
    // 如果当前配置了规则
    if (rules[ruleKey]) {
      rules[ruleKey].forEach(valid => {
        // 获取当前校验结果
        failMessage = failMessage || valid(values[ruleKey])
        // 如果当前校验失败
        result = result && !failMessage
      })
      // 如果当前校验失败
      if (!result) {
        failField = ruleKey
      }
    }
    // 索引累加
    index++
  }
  return [failField, failMessage]
}




// WEBPACK FOOTER //
// ./src/utils/validate.js